import { Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { record_type, class_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { Profile__HasAccessToAdmin_244AC511, Profile__ProjectPermissions_244AC511, User_$reflection, Profile_$reflection, ProjectConfig_$reflection } from "../ClientTypes.fs.js";
import { contains } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { Scope } from "../ServerTypes.fs.js";
import { safeHash, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createContext } from "../fable_modules/Feliz.2.9.0/./Internal.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";

export class ProjectContext extends Record {
    constructor(ProjectId, Config, Profile, User) {
        super();
        this.ProjectId = ProjectId;
        this.Config = Config;
        this.Profile = Profile;
        this.User = User;
    }
}

export function ProjectContext_$reflection() {
    return record_type("EPM.App.Hooks.UseProjectContext.ProjectContext", [], ProjectContext, () => [["ProjectId", class_type("System.Guid")], ["Config", ProjectConfig_$reflection()], ["Profile", Profile_$reflection()], ["User", User_$reflection()]]);
}

export function ProjectContext__HasPermission_Z5895E356(this$, permission) {
    const permissions = Profile__ProjectPermissions_244AC511(this$.Profile, this$.ProjectId);
    if (contains(new Scope(0, []), permissions, {
        Equals: equals,
        GetHashCode: safeHash,
    })) {
        return true;
    }
    else {
        return contains(permission, permissions, {
            Equals: equals,
            GetHashCode: safeHash,
        });
    }
}

export function ProjectContext__get_HasAccessToAdmin(this$) {
    return Profile__HasAccessToAdmin_244AC511(this$.Profile, this$.ProjectId);
}

export const Context_ProjectContext = createContext("Project", undefined);

export function useFeliz_React__React_useProjectContext_Static() {
    return reactApi.useContext(Context_ProjectContext);
}

